import styled from 'styled-components';
import { media } from '@minecraft.themes';
import Modal, { StyledModalFooter, StyledModalBody, StyledModalHeader, StyledCloseButton } from '@minecraft.modal';

export const Container = styled.div`
  max-width: 78.25rem;
  width: 100%;
  margin: 0 auto;
  color: ${(props): string => props.theme.colors.primary.darkGrey};
  line-height: normal;
  padding-bottom: 2.625rem;

  ${media.sm`
    padding: 0 1.125rem;
    padding-bottom: 0;
  `}

  ${media.md`
    padding: 0 1.625rem;
  `}
`;

export const Section = styled.section`
  padding: 1rem;
  box-sizing: border-box;
  ${media.sm`
    padding: 0;
    height: 25.5rem;
  `};
`;

/* TODO: 'as any' should be removed after styled-components update https://github.com/microsoft/TypeScript/issues/37597 */
export const SectionFlex = styled(Section as any)`
  padding: 1rem;
  padding-top: 1.4375rem;
  padding-bottom: 1.875rem;
  display: flex;
  flex-direction: column;
  background-color: ${(props): string => props.theme.colors.primary.white};

  ${media.sm`
    padding: 0;
    flex-direction: row;
    justify-content: space-between;
  `}
`;

/* TODO: 'as any' should be removed after styled-components update https://github.com/microsoft/TypeScript/issues/37597 */
export const SectionCenter = styled(Section as any)`
  text-align: center;
  padding-top: 5.625rem;
  padding-bottom: 2.5rem;
  max-width: 18rem;
  align-self: center;
  img {
    height: 5.75rem;
  }

  img {
    margin-bottom: 2.25rem;
  }

  ${media.sm`
    padding-top: 0.625rem;
    padding-bottom: 5.8125rem;
    align-items: center;
    img {
      height: 9.3125rem;
      margin-top: 0;
    }
  `};
`;

/* TODO: 'as any' should be removed after styled-components update https://github.com/microsoft/TypeScript/issues/37597 */
export const StyledBenefitsSection = styled(SectionFlex as any)`
  img {
    max-width: 11.625rem;
  }

  ${media.sm`
    padding-left: 4rem;
    padding-right: 1.5rem;
    padding-top: 0.625rem;
    padding-bottom: 5.8125rem;
    align-items: center;

    img {
      max-width: 10.75rem;
    }
  `};

  ${media.md`
    img {
      max-width: 16.5rem;
    }
  `};
`;

export const MainHeader = styled.h1`
  font-size: 1.5rem;
  line-height: normal;
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const SectionHeader = styled.h2`
  color: ${(props): string => props.theme.colors.accent.blueActive};
  font-size: 1.375rem;
  line-height: normal;
  font-weight: 500;
  margin-bottom: 0.875rem;

  ${media.sm`
    font-size: 1.5rem;
    margin-bottom: 0.6875rem;
  `}
`;

export const SectionBlock = styled.div`
  text-align: left;
  ${media.sm`
    max-width: 12.5rem;
  `}
`;

export const Text = styled.p`
  margin: 0;
  line-height: 1.5;

  ${media.sm`
    font-size: 1.125rem;
  `};
`;

export const ImageWrapper = styled.div`
  text-align: center;
  flex-grow: 1;
  display: flex;

  img {
    margin: auto;
  }

  ${media.sm`
    flex-grow:0;
    display:block;
    font-size: 1.125rem;
  `};
`;

export const StyledModal = styled(Modal)`
  max-width: 37.5rem;
  /* TODO: 'as any' should be removed after styled-components update https://github.com/microsoft/TypeScript/issues/37597 */
  ${StyledCloseButton as any} {
    display: none;
  }

  ${StyledModalHeader as any} {
    display: none;
    ${media.sm`
      display: block;
    `}
  }

  ${StyledModalFooter as any} {
    justify-content: center;
  }

  ${StyledModalBody as any} {
    padding: 0;
    display: flex;
    flex-direction: column;
  }
`;
